module.exports = __webpack_public_path__ + "img/consult_info6.bb22954a.png";